import {
  Dialog,
  DialogContent,
  Button,
  Typography,
  TextField,
  // Checkbox,
  Box,
  // FormControlLabel,
} from "@material-ui/core";
//import InputAdornment from "@material-ui/core/InputAdornment";
import { makeStyles } from "@material-ui/styles";
import { useEffect, useState } from "react";
import { useTranslate } from "react-admin";
import SFDialogTitle from "../../../../../components/SFDialogTitle";

const useStyles = makeStyles((theme) => ({
  paper: {
    margin: "50px auto",
    width: 668,
    maxWidth: 1200,

    borderRadius: "10px",
  },
  dialogContainer: {
    margin: "0 auto",
  },
  payment: {
    color: theme.orange,
    fontSize: 30,
    fontWeight: "bold",

    margin: "20px auto 0",
    display: "table",
  },

  buttonTakePhoto: {
    width: 287,
    height: 55,
    backgroundColor: theme.orange,
    border: "1px  #828282",
    borderRadius: 7,
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  },
  textButtonTakePhoto: {
    color: "white",
  },
  topicBank: {
    fontSize: 16,
    fontWeight: "bold",
    margin: "10px  0 0px 0",
  },
  detailBank: {
    fontSize: 24,
    fontWeight: "bold",
    fontStyle: "normal",
    color: theme.orange,
  },
  uploadContainer: {
    marginTop: 12,
    display: "grid",
    gridTemplateColumns: "50% 50%",
    justifyItems: "start",
  },
  correctMini: {
    width: 21,
    height: 21,
    margin: 5,
  },
  selectCustomerBankContainer: {
    width: 228,
    height: 55,
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
  },
  halfContainer: {
    display: "grid",
    gridTemplateRows: "75px 75px",
    padding: "0 70px",
    gap: 10,
    marginTop: 25,
    height: "100%",
  },
  changeDisplayContainer2: {
    display: "grid",

    alignItems: "center",
    justifyItems: "center",
    backgroundColor: theme.lightGray,
    borderRadius: 12,
  },
  changeDisplayContainer: {
    display: "grid",
    gridTemplateColumns: "33% 34% 33%",

    alignItems: "center",
    justifyItems: "center",
    backgroundColor: theme.lightGray,
    borderRadius: 12,
  },
  changeText: {
    color: theme.orange,
  },
  changeValueText: {
    color: theme.orange,
    opacity: 0.5,
  },
  input: {
    "&::placeholder": {
      fontSize: 16,
      color: theme.darkGray,
      fontWeight: 400,
    },
  },
  changeInputContainer: {
    backgroundColor: theme.lightGray,
    borderWidth: 0,
  },
  adornment: {},
  adornmentText: {
    color: theme.orange,
  },
  noBorder: {
    border: "none",
  },
  buttonContainer: {
    display: "grid",
    gridTemplateColumns: "50% 50%",
  },
}));

const Cash = ({
  openDialog,
  onClose,
  onSubmit,
  cashValue,
  fullPaymentBeforeChange,
  setFullPaymentBeforeChange,
  noChange, //NO Change Dialog
}) => {
  const translate = useTranslate();
  const classes = useStyles();
  const [cashInputValue, setCashInputValue] = useState();
  const [changeValue, setChangeValue] = useState(0);
  useEffect(() => {
    if (cashInputValue) {
      setChangeValue(cashInputValue - cashValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cashInputValue]);

  return (
    <Dialog
      fullWidth
      onClose={() => {
        onClose();
      }}
      aria-labelledby="customized-dialog-title"
      open={openDialog}
      classes={{ root: classes.dialogContainer, paper: classes.paper }}
    >
      <SFDialogTitle
        title={translate("ra.text.paymentMethod.paidbyCash")}
        onClose={() => {
          onClose();
        }}
      />
      <DialogContent>
        <Typography align="center">
          {translate("ra.text.paymentMethod.totalAmount")}
        </Typography>
        <Typography align="center" variant="h4" style={{ marginTop: 10 }}>
          THB {cashValue}
        </Typography>
        <Box className={classes.halfContainer}>
          <TextField
            type="number"
            variant="outlined"
            value={cashInputValue}
            onChange={(e) => {
              setCashInputValue(e.target.value);
              setFullPaymentBeforeChange(e.target.value);
            }}
            inputProps={{
              min: 0,

              style: {
                textAlign: "center",
                fontSize: 32,
                fontWeight: 700,
                color: "#FA9917",
              },
            }} // the change is here
            InputProps={{
              startAdornment: <Box style={{ width: 90 }}></Box>,
              endAdornment: (
                <Box style={{ width: 90 }}>
                  <Typography align="center" className={classes.adornmentText}>
                    THB
                  </Typography>
                </Box>
              ),
              classes: { input: classes.input },
            }}
            placeholder={translate("ra.text.paymentMethod.enterReceiveMoney")}
          ></TextField>

          <TextField
            type="number"
            value={changeValue}
            variant="outlined"
            disabled
            inputProps={{
              min: 0,
              style: {
                textAlign: "center",
                fontSize: 32,
                fontWeight: 700,
                color: "#FA9917",
                opacity: 0.5,
              },
            }} // the change is here
            InputProps={{
              startAdornment: (
                <Box style={{ width: 90 }} className={classes.adornment}>
                  <Typography align="center" className={classes.adornmentText}>
                    {translate("ra.text.paymentMethod.change")}
                  </Typography>
                </Box>
              ),
              endAdornment: (
                <Box style={{ width: 90 }} className={classes.adornment}>
                  {" "}
                  <Typography align="center" className={classes.adornmentText}>
                    THB
                  </Typography>
                </Box>
              ),
              classes: {
                root: classes.changeInputContainer,
                notchedOutline: classes.noBorder,
              },
              disableUnderline: true, // <== added this
            }}
            placeholder={translate("ra.text.paymentMethod.enterReceiveMoney")}
          ></TextField>
        </Box>
      </DialogContent>
      <Box className={classes.buttonContainer}>
        <Button
          autoFocus
          variant="contained"
          onClick={onSubmit}
          style={{
            // alignContent: "center",
            borderRadius: 0,
            height: 69,
            fontSize: 26,
            marginTop: 50,
            backgroundColor: "#828282",
          }}
        >
          <Typography align="center" style={{ color: "white", fontSize: 26 }}>
            {translate("ra.text.skip")}
          </Typography>
        </Button>
        <Button
          autoFocus
          variant="contained"
          onClick={onSubmit}
          disabled={!cashInputValue || cashValue > cashInputValue}
          color="primary"
          style={{
            // alignContent: "center",
            borderRadius: 0,
            height: 69,
            fontSize: 26,
            marginTop: 50,
          }}
        >
          <Typography align="center" style={{ color: "white", fontSize: 26 }}>
            {translate("ra.text.paymentMethod.pay")}
          </Typography>
        </Button>
      </Box>
    </Dialog>
  );
};

export default Cash;
